<template>
  <div class="message-box"
       v-if="isShowMessageBox">
    <div class="mask"
         :class="[maskClass]"
         @click="()=>{this.closeOnClickModal?colse():false}"></div>
    <div class="message-content" :class="[messageContentClass]">
      <div class="main" :class="[ contentClasses ]">
        <span class="btn-close" v-if="showClose" @click="colse"></span>
        <h3 v-if="title" :class="['title',titleClass]">{{title}}</h3>
        <p class="content"
           v-html="message"></p>
        <div>
          <input type="text"
                 v-model="inputValue"
                 v-if="showInput"
                 ref="input"
                 @keyup.enter="confirm">
        </div>
      </div>
      <div class="btn-group">
        <button class="btn btn-cancel"
                 :class="[ cancelButtonClasses ]"
                type="button"
                @click="cancel"
                v-show="showCancelButton">{{cancelButtonText}}</button>
        <button class="btn btn-confirm"
        :class="[ confirmButtonClasses ]"
                type="button"
                @click="confirm"
                v-show="showConfirmButton">{{confirmButtonText}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ems-messageBox',
  mixins: [],
  components: {},
  props: {
    title: {
      type: String,
      default: '标题'
    },
    message: {
      type: String,
      default: '这是弹框内容'
    },
    showInput: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: false
    },
    inputValue: {
      type: String,
      default: ''
    },
    showCancelButton: {
      type: Boolean,
      default: false
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    cancelButtonText: {
      type: String,
      default: '取消'
    },
    confirmButtonText: {
      type: String,
      default: '确定'
    },
    confirmButtonClasses: {
      type: String,
      default: ''
    },
    cancelButtonClasses: {
      type: String,
      default: ''
    },
    contentClasses: {
      type: String,
      default: ''
    },
    maskClass: {
      type: String,
      default: ''
    },
    titleClass: {
      type: String,
      default: ''
    },
    messageContentClass: {
      type: String,
      default: ''
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isShowMessageBox: false,
      resolve: '',
      reject: '',
      promise: '' // 保存promise对象
    }
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  created () {},
  mounted () {},
  methods: {
    // 确定,将promise断定为resolve状态
    confirm () {
      this.isShowMessageBox = false
      if (this.showInput) {
        this.resolve(this.inputValue)
      } else {
        this.resolve('confirm')
      }
      this.remove()
      this.$emit('confirm')
    },
    // 取消,将promise断定为reject状态
    cancel () {
      this.isShowMessageBox = false
      this.resolve('cancel')
      this.remove()
      this.$emit('cancel')
    },
    colse () {
      this.isShowMessageBox = false
      this.remove()
    },
    // 弹出messageBox,并创建promise对象
    showMsgBox (options) {
      this.isShowMessageBox = true
      if (options && Object.keys(options).length) {
        for (const key in options) {
          this[key] = options[key]
        }
      }
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
      // 返回promise对象
      return this.promise
    },
    remove () {
      setTimeout(() => {
        this.destroy()
      }, 300)
    },
    destroy () {
      this.isShowMessageBox = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
